import React from 'react';
import { FieldTextAreaWithReduxProps } from './types';
import { FieldTextArea } from '.';

export const FieldTextAreaWithRedux = ({
  meta: { error, submitFailed, valid },
  input: { value, ...inputProps },
  rows,
  ...html
}: FieldTextAreaWithReduxProps) => (
  <FieldTextArea
    {...html}
    {...inputProps}
    rows={rows}
    value={value}
    isShowingError={submitFailed && !valid}
    error={error ? { message: error } : undefined}
  />
);
